export enum EnumCodeTypes {
  ERROR = 'danger',
  SUCCESS = 'success',
  INFO = 'info',
}

interface TMapCode {
  [key: string]: {
    [key: string]: {
      type: 'success' | 'warning' | 'danger' | 'info';
      message: string;
    };
  };
}

export const mapCodes: TMapCode = {};
